import lodash from 'lodash'
import React, { useEffect, useMemo } from 'react'
import { ReactElement } from 'react'

import { useField } from '../../../../../../../../1stlog-ui/src/components/Field'
import HazmatOption from './HazmatOption'
import ReusableBoxOption from './ReusableBoxOption'

export type TServiceOptionComponentProps = {
  label: string
  defaultValue?: any
  disableService: () => void
  coliFieldName: string
  readonly: boolean
}

const components = {
  // bool: BoolService,
  // currency: CurrencyOption
  hazmat: HazmatOption,
  reusableBox: ReusableBoxOption,
}

type TServiceOptionProps = {
  disableService: () => void
  coliFieldName: string
  readonly?: boolean
  serviceName: string
}

const ServiceOption = (props: TServiceOptionProps): ReactElement => {
  const { disableService, coliFieldName, readonly, serviceName } = props

  const type = useField('type')
  const defaultValue = useField('defaultValue')
  const [value, setValue] = useField('value', { asState: true })
  const label = useField('label')

  const Component = useMemo(() => lodash.get(components, type), [type])

  useEffect(() => {
    if (!value && value !== defaultValue) {
      setValue(defaultValue)
    }
  }, [value])

  return Component ? (
    <div className="d-flex">
      <Component
        label={label}
        defaultValue={defaultValue}
        disableService={disableService}
        coliFieldName={coliFieldName}
        readonly={readonly}
        serviceName={serviceName}
      />
    </div>
  ) : (
    <></>
  )
}

export default ServiceOption
